import { gql } from '@apollo/client'

export const ElementMetadataFragment = gql`
    fragment elementMetadata on Metadata {
        updated
        modifiedBy {
            profileInfo {
                firstName
                lastName
            }
        }
    }
`
